import React from 'react';

const TAB_PATHS = {
  descripcion: (
    <>
      <path d='M7 4.5h7l4 4V19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-13a1.5 1.5 0 0 1 1-1.5z' />
      <path d='M14 4.5V9h4' />
      <path d='M9 13h6M9 16h6' />
    </>
  ),
  itinerario: (
    <>
      <path d='M5 17a3 3 0 1 0 0 .01M19 7a3 3 0 1 0 0 .01' />
      <path d='M8 17h4c3 0 4-2 4-4V9M10 7h6' />
      <path d='m12 4-3 3 3 3' />
    </>
  ),
  incluye: (
    <>
      <circle cx='12' cy='12' r='9' />
      <path d='m8 12 2.5 2.5L16 9' />
    </>
  ),
  'no-incluye': (
    <>
      <circle cx='12' cy='12' r='9' />
      <path d='M8.5 8.5l7 7M15.5 8.5l-7 7' />
    </>
  ),
  observaciones: (
    <>
      <circle cx='12' cy='12' r='9' />
      <path d='M12 11v6M12 7h.01' />
    </>
  ),
  hoteles: <path d='M3 19v-8h18v8M5 11V7h6v4M13 11V6h6v5M3 16h18M6 19v2M18 19v2' />,
  transporte: <path d='M3 11l19-9-9 19-2-8-8-2z' />,
  contacto: (
    <>
      <path d='M4 5h16v12H7l-3 3V5z' />
      <path d='m5 6 7 6 7-6' />
    </>
  ),
};

export function PreviewTabIcon({ tabId }) {
  const paths = TAB_PATHS[tabId];
  if (!paths) return null;
  return (
    <svg aria-hidden='true' viewBox='0 0 24 24'>
      {paths}
    </svg>
  );
}

export function PreviewMailIcon() {
  return (
    <svg aria-hidden='true' viewBox='0 0 24 24'>
      <rect height='14' rx='2.5' width='18' x='3' y='5' />
      <path d='m4 7 8 6 8-6' />
    </svg>
  );
}

export function PreviewWhatsappIcon() {
  return (
    <svg aria-hidden='true' viewBox='0 0 24 24'>
      <path d='M17.5 14.4c-.3-.1-1.7-.8-2-1-.3-.1-.5-.1-.7.1-.2.3-.7 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.1.2-.3.3-.4.1-.2 0-.4 0-.5C10 9 9.6 8 9.4 7.5c-.2-.4-.4-.4-.5-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s1 2.5 1.1 2.7c.1.2 2 3 4.8 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.3.2-.7.2-1.2.2-1.3-.1-.2-.3-.2-.5-.3zM12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2zm0 18.3a8.3 8.3 0 0 1-4.2-1.1l-.3-.2-3.1.8.8-3-.2-.3A8.3 8.3 0 1 1 12 20.3z' />
    </svg>
  );
}
